import { useEffect } from "react";
import { EnabledLensSources } from "../components/EnabledLensSources";
import { LensSourcesOperations } from "../domain/LensSourcesOperations";
import { useEnabledLensSources } from "../hooks";
import { useLensSourcesDomain } from "../hooks/useLensSourcesDomain";

export const EnabledLensSourcesListContainer = () => {
    const { sources, loading, error } = useEnabledLensSources();
    const { replace, filter, lensSources } = useLensSourcesDomain();

    useEffect(() => {
        replace(LensSourcesOperations.createFromQuery(sources));
    }, [replace, sources]);

    return (
        <EnabledLensSources sourcesDomainModel={lensSources} loading={loading} error={error} setSearchValue={filter} />
    );
};
